export default __webpack_public_path__ + "0fb727bd0f18d4f919704ef5dfe5cfea.svg";